/** A question's intro, headed by which subagent is asking; the user can't see its conversation. */
export function introForAsker(
    subagentDescription: string | undefined,
    intro?: string,
): string | undefined {
    if (!subagentDescription) {
        return intro;
    }
    const asker = `The subagent working on "${subagentDescription}" asks:`;
    return intro ? `${asker}\n\n${intro}` : asker;
}
